// import React, { useState,useEffect } from 'react';
// import './ExtendedWarrantyDetails.scss';
// import { useLocation, useNavigate } from 'react-router-dom';
// import ROUTES_NAVIGATION from '../../../../../../routes/routes';
// import axiosInstance from '../../../../../../http.common';

// const ExtendedWarrantyDetails = () => {
//   const navigate = useNavigate();
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [remark, setRemark] = useState('');
//   const [actionType, setActionType] = useState('');
//   const [ExtWarrantyData,setExtWarrantyData] = useState([])
//   const location = useLocation();
//   const powarrantyId = location?.state?.data?.powarrantyId
//   const Token = localStorage.getItem("authToken")
//   console.log("powarrantyId",powarrantyId);
  
//   const openModal = (type) => {
//     setActionType(type);
//     setIsModalOpen(true);
//   };

//   const closeModal = () => {
//     setIsModalOpen(false);
//     setRemark('');
//   };

//   const fetchDepartmentEdit = async () => {
//     try{
//       const response = await axiosInstance.get(`/extendedwarranty/approval-details/${powarrantyId}`,{
//         headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${Token}`,
//         },
//     })
//     const formatData = response.data.data[0];
//     setExtWarrantyData(formatData)
//     console.log(response, "depatartment DATA")
  
//   }catch(error){
//       console.log(error)
//     }
  
//   }
  
//   useEffect(() => {
//     fetchDepartmentEdit()
//   },[])

//   const handleSubmit = () => {
//     // Handle form submission here (e.g., API call)
//     console.log(`Action: ${actionType}, Remark: ${remark}`);
//     closeModal();
//   };
//   console.log(ExtWarrantyData, "EXT Warranty DATA")
//   return (
//     <>
//       <div className='OnboardManagamentContainer'>
//         <div className='OnboardManagamentbuttonContainer'>
//           <h5>Extended Warranty Details</h5>
//         </div>
//         <div className='totalvaluescontainer col-xl-6 col-lg-12 mt-2 mb-2'>
//           <button
//             className='addcustomerbutton'
//             onClick={() => openModal('Approve')}
//           >
//             Approve
//           </button>
//           <button
//             className='reject-button'
//             onClick={() => openModal('Reject')}
//           >
//             Reject
//           </button>
//         </div>
//       </div>
//       <div className="details-section">
//         <h5 className="mt-2 mb-2 headerdetails">Order Details</h5>
//         <div className="detail-grid">
//           {/* Order Details Content */}
//           <div className="details-item">
//             <span className="details-label">Dealer Name</span>
//             <span className="details-value">{ExtWarrantyData?.dealer_name}</span>
//           </div>
//           <div className="details-item">
//             <span className="details-label">PO No.</span>
//             <span className="details-value">{ExtWarrantyData?.po_number}</span>
//           </div>
//           <div className="details-item">
//             <span className="details-label">Warrenty Type</span>
//             <span className="details-value">{ExtWarrantyData?.warrantyType}</span>
//           </div>
//           <div className="details-item">
//             <span className="details-label">Warranty Days</span>
//             <span className="details-value">{ExtWarrantyData?.warrantyDay}</span>
//           </div>
//           <div className="details-item">
//             <span className="details-label">Warranty From</span>
//             <span className="details-value">{ExtWarrantyData?.warrantyFrom?ExtWarrantyData?.warrantyFrom:"-"}</span>
//           </div>
//           <div className="details-item">
//             <span className="details-label">Warranty To</span>
//             <span className="details-value">{ExtWarrantyData?.warrantyTo?ExtWarrantyData?.warrantyTo:"-"}</span>
//           </div>
//         </div>
//       </div>

//       {/* Modal Component */}
//       {isModalOpen && (
//         <div className="modal-overlay">
//           <div className="modal-content">
//             <h5>{actionType} Remark</h5>
//             <textarea
//               value={remark}
//               onChange={(e) => setRemark(e.target.value)}
//               placeholder="Add your remark here"
//               rows="4"
//               className="remark-textarea"
//             />
//             <div className="modal-buttons">
//               <button onClick={handleSubmit} className="submit-button">
//                 Submit
//               </button>
//               <button onClick={closeModal} className="cancel-button">
//                 Cancel
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default ExtendedWarrantyDetails;

import React, { useState, useEffect } from 'react';
import './ExtendedWarrantyDetails.scss';
import { useLocation, useNavigate } from 'react-router-dom';
import ROUTES_NAVIGATION from '../../../../../../routes/routes';
import axiosInstance from '../../../../../../http.common';
import backicon from '../../../../../../Assets/icons/backIcon.svg'

const InspectionExtendedWarrantyDetails = () => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [remark, setRemark] = useState('');
  const [actionType, setActionType] = useState('');
  const [ExtWarrantyData, setExtWarrantyData] = useState([]);
  const location = useLocation();
  const jobCardId = location?.state?.data?.job_card_id;
  const Token = localStorage.getItem("authToken");

  // Fetching extended warranty details
  const fetchDepartmentEdit = async () => {
    try {
      const response = await axiosInstance.get(`/warrantyinspection/approval-details/${jobCardId}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Token}`,
        },
      });
      const formatData = response.data.data[0];
      setExtWarrantyData(formatData);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchDepartmentEdit();
  }, []);

  // Function to handle the approval or rejection API call
  const handleApprovalAPI = async (isApproved, rejactRemark = '') => {
    try {
      const payload = {
       
        isApproved,
        rejactRemark,
      };

      const response = await axiosInstance.patch(`/warrantyinspection/update-status-arrpoval/${jobCardId}`, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Token}`,
        },
      });

      if (response?.status==200) {
        alert(`${isApproved ? 'Approval' : 'Rejection'} successful!`);
        navigate(ROUTES_NAVIGATION.INSPECTIONEXTENDEDWARRANTYAPPROVAL);
      } 
    } catch (error) {
      console.error("API Error:", error);
      alert("An error occurred while processing the request.");
    }
  };

  // Open modal for rejection
  const openRejectModal = () => {
    setActionType('Reject');
    setIsModalOpen(true);
  };

  // Handle the submit action for rejection
  const handleRejectSubmit = () => {
    handleApprovalAPI(0, remark); // Reject with remark
    closeModal();
  };

  // Approve without opening the modal
  const handleApprove = () => {
    handleApprovalAPI(1); // Approve without remark
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setRemark('');
  };

  return (
    <>
      <div className='OnboardManagamentContainer'>
        <div className='OnboardManagamentbuttonContainer'>
          <h5>Extended Warranty Details</h5>
        </div>
        <div className='totalvaluescontainer col-xl-6 col-lg-12 mt-2 mb-2'>
          <button
            className='addcustomerbutton'
            onClick={handleApprove}
          >
            Approve
          </button>
          <button
            className='reject-button'
            onClick={openRejectModal}
          >
            Reject
          </button>
        </div>
      </div>

      {/* Order Details Section */}
      <div className="backbutton mt-2 mb-2" onClick={()=>navigate(-1)}>
            <img src={backicon} alt="back" />
            <span className="backbtntitle">Inspection Extended Warranty Details</span>
          </div>
      <div className="details-section">
       
        <div className="detail-grid">
        <div className="details-item">
            <span className="details-label">JobCard No.</span>
            <span className="details-value">{ExtWarrantyData?.job_card_no}</span>
          </div>
          <div className="details-item">
            <span className="details-label">Dealer Name</span>
            <span className="details-value">{ExtWarrantyData?.dealer_name}</span>
          </div>
          
          <div className="details-item">
            <span className="details-label">Contact No.</span>
            <span className="details-value">{ExtWarrantyData?.contact_no}</span>
          </div>
          <div className="details-item">
            <span className="details-label">Vin No.</span>
            <span className="details-value">{ExtWarrantyData?.vin_no}</span>
          </div>
          <div className="details-item">
            <span className="details-label">Inspection By</span>
            <span className="details-value">{ExtWarrantyData?.inspection_by || "-"}</span>
          </div>
          <div className="details-item">
            <span className="details-label">Transaction Date</span>
            <span className="details-value">{ExtWarrantyData?.transaction_date || "-"}</span>
          </div>
        </div>
      </div>

      {/* Modal for Rejection */}

      {isModalOpen && (
                <div className="customModalOverlay">
                    <div className="custom-modal">
                        <div className="custom-modal-header">
                            <h6 style={{fontSize:"18px"}}>Remarks</h6>
                            <button className="close-button" onClick={closeModal}>
                                ×
                            </button>
                        </div>
                        <div className="custom-modal-body">

                        <textarea
              value={remark}
              onChange={(e) => setRemark(e.target.value)}
              placeholder="Add your remark here"
              rows="4"
              className="remark-textarea"
            />
                        </div>
                        <div className="custom-modal-footer">
                            <button
                                className="btn btn-primary"
                                style={{ background: "red", color: "white", border: "none" }}
                                onClick={handleRejectSubmit}
                            >
                                Reject
                            </button>
                            <button className="btn btn-primary" onClick={closeModal}>
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}    

      {/* {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h5>Reject Remark</h5>
            <textarea
              value={remark}
              onChange={(e) => setRemark(e.target.value)}
              placeholder="Add your remark here"
              rows="4"
              className="remark-textarea"
            />
            <div className="modal-buttons">
              <button onClick={handleRejectSubmit} className="submit-button">
                Submit
              </button>
              <button onClick={closeModal} className="cancel-button">
                Cancel
              </button>
            </div>
          </div>
        </div>
      )} */}
    </>
  );
};

export default InspectionExtendedWarrantyDetails;

